import { mount } from '../../../js/dom-lifecycle';
import { Chart } from '../charts-bundle';
import { resolveColor } from './charts';

const COLORS = { action: '--primary', global: '--gray-600', entry: '--success', preliminary: '--warning-dark' };
const GROUP_COLORS = ['--primary', '--purple', '--danger', '--warning', '--success'];

const formatDate = (ms) => new Date(ms).toLocaleString('pl-PL', { dateStyle: 'short', timeStyle: 'short' });

function scoreDatasets({ points, entries }) {
    return [
        {
            label: 'Ocena w tej akcji',
            data: points.filter(p => p.action !== null).map(p => ({ x: p.x, y: p.action, label: p.label })),
            borderColor: resolveColor(COLORS.action),
            backgroundColor: resolveColor(COLORS.action),
            stepped: 'before',
            pointRadius: 4,
        },
        {
            label: 'Ocena łączna (wszystkie akcje)',
            data: points.filter(p => p.global !== null).map(p => ({ x: p.x, y: p.global, label: p.label })),
            borderColor: resolveColor(COLORS.global),
            backgroundColor: resolveColor(COLORS.global),
            borderDash: [6, 4],
            stepped: 'before',
            pointRadius: 3,
        },
        {
            type: 'scatter',
            label: 'Ocena zgłoszenia',
            data: entries.filter(e => e.score !== null).map(e => ({ x: e.x, y: e.score, label: e.label })),
            backgroundColor: resolveColor(COLORS.entry),
            pointRadius: 7,
            pointStyle: 'rectRounded',
        },
        {
            type: 'scatter',
            label: 'Wynik wstępny',
            data: entries.filter(e => e.preliminary !== null).map(e => ({ x: e.x, y: e.preliminary, label: e.label })),
            borderColor: resolveColor(COLORS.preliminary),
            backgroundColor: 'transparent',
            borderWidth: 2,
            pointRadius: 6,
        },
    ];
}

function groupDatasets({ points, groups }) {
    const withGroups = points.filter(p => p.groups);
    return groups.map(({ key, label }, i) => ({
        label,
        data: withGroups
            .filter(p => p.groups[key] !== undefined)
            .map(p => ({ x: p.x, y: p.groups[key], label: p.label })),
        borderColor: resolveColor(GROUP_COLORS[i]),
        backgroundColor: resolveColor(GROUP_COLORS[i]),
        stepped: 'before',
        pointRadius: 3,
    }));
}

mount('script[data-loyalty-chart]', function () {
    const data = JSON.parse(this.textContent);
    const canvas = document.getElementById('loyaltyChart');
    if (!canvas) return;

    const chart = new Chart(canvas.getContext('2d'), {
        type: 'line',
        data: { datasets: scoreDatasets(data) },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            parsing: false,
            plugins: {
                legend: { position: 'bottom' },
                tooltip: {
                    callbacks: {
                        title: (items) => formatDate(items[0].parsed.x),
                        afterLabel: (item) => item.raw.label ?? '',
                    },
                },
            },
            scales: {
                x: { type: 'linear', ticks: { callback: formatDate, maxTicksLimit: 6 } },
                y: { min: 0, max: 100, ticks: { stepSize: 20 } },
            },
        },
    });

    document.querySelectorAll('[data-loyalty-chart-tab]').forEach(button => {
        button.addEventListener('click', () => {
            document.querySelectorAll('[data-loyalty-chart-tab]')
                .forEach(b => b.classList.toggle('active', b === button));
            chart.data.datasets = button.dataset.loyaltyChartTab === 'groups'
                ? groupDatasets(data)
                : scoreDatasets(data);
            chart.update();
        });
    });
});
